import React, { useEffect, useState } from "react";
import CustomModal from "../../components/customModal";
import CustomForm from "../../components/customForm";
import { Outlet } from "react-router-dom";
import Footer from "../../components/footer";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space } from 'antd';
import SellBikeForm from "../../components/sellBikeForm";
import { useNavigate } from "react-router-dom";
export default function MainLayout() {
  const token = localStorage.getItem("access_token");
  const user_id = localStorage.getItem("user_id");
const navigate =useNavigate();
  const [openModal, setOpenModal] = React.useState(false);
    const [openModal4, setOpenModal4] = useState(false);
  
  const [isExpanded, setIsExpanded] = React.useState(false);

  const toggleContainer = () => {
    setIsExpanded(!isExpanded);
  };
  
  return (
    <>
      {/* <CustomModal
        title="Sell Your Car"
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <CustomForm setOpenModal={setOpenModal} />
      </CustomModal> */}


      <CustomModal
        title="Sell Your Car"
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <CustomForm
          setOpenModal={setOpenModal}
          // cities={modifiedCities}
          // province={modifiedProvince}
        />
      </CustomModal>
      <CustomModal
        title="Sell Your Bike"
        openModal={openModal4}
        setOpenModal={setOpenModal4}
      >
        <SellBikeForm
          setOpenModal={setOpenModal4}
          // cities={modifiedCities}
          // province={modifiedProvince}
        />
      </CustomModal>
     
      <Outlet />
      <Footer />


      {/* <div
        style={{
          position: "fixed",
          bottom: "16px",
          right: "16px",
          zIndex: 1000,
          textAlign: "right",
        }}
      >
{isExpanded && (
          <div
            className="bg-white shadow-lg rounded-lg p-4 mb-2"
            style={{ width: "200px" }}
          >
            <button
              className="w-full text-left mb-2 bg-gray-100 p-2 rounded hover:bg-gray-200"
              onClick={() => {
                if (token && user_id) {
                  setOpenModal(true);
                } else {
                  navigate("/login");
                }
              }}
            >
              Sell a Car
            </button>
            <button
              className="w-full text-left bg-gray-100 p-2 rounded hover:bg-gray-200"
              onClick={() => {
                if (token && user_id) {
                  setOpenModal4(true);
                } else {
                  navigate("/login");
                }
              }}
            >
              Sell a Bike
            </button>
          </div>
        )}
    <button
    onClick={toggleContainer}
      className="bg-green-500  text-white p-4 rounded-full shadow-lg flex items-center justify-center hover:bg-green-600 transition duration-300"
    >
      <PlusOutlined className="text-md mr-2" />
      Sell
    </button>
    </div> */}
  

     
    </>
   
  );
}
